// extracted by mini-css-extract-plugin
export default {"button":"AzRacSviobUTG4wu27DZ"};